const zh = {
	title: '请选择您的账户类型',
	subtitle: '为配合监管要求，请根据真实情况选择贵公司业务的类型',
	tip: '提示：如果您同时开展不同类型的业务，请申请多个PingPong Checkout账号',
	tradeOfGoods: '货物贸易',
	tradeOfService: '服务贸易',
	confirm: '确认',
	cancel: '退出登录',
	pleaseSelectOne: '请选择一个类型',
	whenConfirming: '{#@email@#}的贸易类型为“{#@type@#}”，确认后不可修改。是否确认？',
	tipWord: '注意',
	cancelWord: '取消',
	activedWrods: '该账号只能添加类型为“{#@type@#}”的网站。',
	onSuccessTip: '操作成功',
	accountType: '商户类型',
	businessType: '业务类型',
	onlineService: '线上服务',
	offlineServices: '全渠道收单'
}

export default zh
